import { ITSelectProps } from '@/components/selects';
import { useWorkspace } from '@/features/workspaces/hooks';
import { Audience } from '@/models/audiences';
import { RootState } from '@/reducers';
import { useGetAudiencesQuery } from '@/services/endpoints/audiences';
import { isEmpty } from 'lodash';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SearchDropdown } from './SearchDropdown';

type IAudienceSelectProps = Partial<ITSelectProps<Audience>> & {
  audienceId?: string;
  isViewMode?: boolean;
};

export const AudienceSelect: FC<IAudienceSelectProps> = ({ audienceId, isViewMode, ...rest }) => {
  const { t } = useTranslation('audience_edit');

  const stashedAudience = useSelector((state: RootState) => state.audienceEdit.audience);
  const workspace = useWorkspace();

  const { isLoading, data } = useGetAudiencesQuery({
    workspaceId: workspace.id,
  });

  const audiences = data?.items || [];
  const audience = audiences.find((a) => a.id === audienceId);
  const validAudiences = isViewMode ? audiences : audiences.filter((a) => a.id !== stashedAudience?.id);

  if (!isLoading && isEmpty(validAudiences)) {
    return (
      <div className='grid h-full place-content-center'>
        <p className='text-sm'>{t('rules.there_are_no_audience')}</p>
      </div>
    );
  }

  const [searchQuery, setSearchQuery] = useState('');

  return (
    <SearchDropdown
      items={searchQuery?.trim() ? validAudiences.filter((item) => item.name.toLowerCase().includes(searchQuery?.trim())) : validAudiences}
      item={audience}
      setItem={(value) => rest.onChange && rest.onChange(value as any)}
      setQuery={setSearchQuery}
      loading={isLoading}
      readOnly={isViewMode}
      openWithFocus={true}
      displayField={'name'}
      placeholder={t('rules.some_audience') as string}
      className={`px-2 py-1 ${rest.className}`}
    >
      {(item) => <div className={'whitespace-nowrap'}>{item.name}</div>}
    </SearchDropdown>
  );
};
